import { gql } from 'graphql-request';

export const GET_CORE_WIDGETS = gql`
  query CoreWidgets {
    coreWidgets {
      my {
        id
        iconHash
        header
        fields {
          id
          viewName
          viewIndex
          access
          path
          api
        }
      }
    }
  }
`;
